module.exports = __webpack_public_path__ + "img/HZ3604-154.785b9d51.jpg";